import { useContext } from "react";
import { OrbitContext } from "../providers/OrbitProvider";

const useOrbitParams = () => {
    const context = useContext(OrbitContext)
    if (context === undefined) {
        throw new Error('useContacts must be used within a ViewerProvider');
    }

    const { loading, setLoading, orbitParams, launchDetails, getLaunchDetails } = context

    return { loading, setLoading, orbitParams, launchDetails, getLaunchDetails }
};

export default useOrbitParams;